import React, { Fragment, useState, useEffect } from 'react';
import { Link } from 'react-router-dom';
import DesktopMenu from 'components/DesktopMenu';
import MobileTabMenu from 'components/MobileTabMenu';
// import logo from 'img/newsfetch-io.png';
import logo from 'img/ozmosys-logo2.png';
//import logoText from 'img/font_rend (2).png';
import betaSign from 'img/beta sign.png';
import { connect } from 'react-redux';
import { Button } from 'reactstrap';
import { useLocation } from 'react-router-dom'

const Header = ({ auth }) => {
    const location = useLocation();
    const [isOpen, toggleMenu] = useState(false);

    return (
        <Fragment>
            {auth.isAuthenticated && location.pathname !== '/404' ?
                <header className="header p-0">
                    <div className="sidebar-container">
                        <DesktopMenu />
                    </div>
                    <div className="mobile_navigation-container">
                        <a href="https://newsfetch.io/pricing/" className="d-flex align-items-center ml-3">
                            {/*<div><img width="150px" src={logo} alt="logoImg" /></div>*/}
                            <div><img height="47px" src={logo} alt="logoImg" /></div>
                            {/*<div style={{ marginLeft: '3px', alignSelf: 'flex-start' }}><img width="35px" src={betaSign} alt="betaSign" /></div>*/}
                        </a>
                        <i
                            onClick={() => toggleMenu(!isOpen)}
                            style={{
                                fontSize: '20px',
                                color: '#0f1c52',
                                cursor: 'pointer',
                                padding: '10px',
                                marginRight: '1rem',
                            }}
                            className={`userMenuMobAndTab fas ${isOpen ? 'fa-times' : 'fa-bars'}`}
                        />
                        {isOpen && <MobileTabMenu isOpen={isOpen} toggler={toggleMenu} />}
                    </div>
                </header>
                :
                <header className="no_auth_header-container">
                    <a href="https://newsfetch.io/" className="d-flex align-items-center ml-3">
                        {/*<div><img width="150px" src={logo} alt="logoImg" /></div>*/}
                        <div><img height="47px" src={logo} alt="logoImg" /></div>
                        {/* <div style={{ marginLeft: '3px', alignSelf: 'flex-start' }}><img width="35px" src={betaSign} alt="betaSign" /></div> */}
                    </a>
                    <div className="no_auth_desktop-container" style={{ marginTop: '10px' }}>
                        {/* <Link to="/sign_in" style={{ color: '#314784' }}>Sign In</Link> */}
                        {/* <a href={new URL(window.location.href).hostname  === 'app.newsfetch.io' ? 'https://newsfetch.io/' : 'https://web2rss-tst.dataprodev.com/'}>
                            <Button className="calltoaction-button" style={{ marginLeft: '15px' }}>
                                Get started
                            </Button>
                        </a> */}
                    </div>
                    <i
                        onClick={() => toggleMenu(!isOpen)}
                        style={{
                            fontSize: '20px',
                            color: '#0f1c52',
                            cursor: 'pointer',
                            padding: '10px',
                            marginRight: '1rem',
                        }}
                        className={`userMenuMobAndTab fas ${isOpen ? 'fa-times' : 'fa-bars'}`}
                    />
                    {isOpen && <MobileTabMenu isOpen={isOpen} toggler={toggleMenu} />}
                </header>
            }
        </Fragment>
    );
};

const mapStateFromProps = ({ auth }) => ({
    auth,
});

export default connect(mapStateFromProps, null)(Header);
